/**
 * @file frontend/src/lib/sw_register.js
 * @description Register the service worker (WP-1.1 PWA scaffolding).
 *
 * Called once from index.js. Tolerates HTTPS-only constraint (SW won't
 * register on http://localhost in some browsers — that's expected).
 */
import { flushQueue } from './offline_queue';
import { api } from './api';

let registration = null;

export function registerServiceWorker() {
  if (typeof navigator === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  // Only register on HTTPS or localhost.
  const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  const isHttps = window.location.protocol === 'https:';
  if (!isHttps && !isLocalhost) return;

  window.addEventListener('load', async () => {
    try {
      registration = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
      console.log('[K12 ERP] Service worker registered:', registration.scope);

      navigator.serviceWorker.addEventListener('message', async (event) => {
        if (event.data?.type === 'replay-pending-logs') {
          // Background sync fired — flush the queue.
          try { await flushQueue(api); } catch (e) { /* ignore */ }
        }
      });
    } catch (err) {
      console.warn('[K12 ERP] Service worker registration failed:', err);
    }
  });

  // Best-effort flush whenever we come back online.
  window.addEventListener('online', () => {
    flushQueue(api).catch(() => {});
  });
}

export function getRegistration() {
  return registration;
}
